// src/shared/jobIds.js
// Deterministic Firestore doc-ID helpers for Job Assist. CommonJS, used from
// both scripts/fetchJobs.js (require) and src/admin/AdminJobAssist.js (import) —
// same reasoning as skillsMatch.js.
//
// The doc ID IS the dedupe mechanism: a posting/source that already exists at
// this ID is never re-touched, which is what makes "never resurface, never
// reapply" and "adding the same source twice just updates it" both trivial.

// Small dependency-free non-cryptographic hash (FNV-1a), hex output — good
// enough to turn an arbitrary string (a WWR guid URL, a pasted job URL, raw
// pasted JD text) into a short, Firestore-doc-ID-safe, stable fragment.
const hashString = (str = "") => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, "0");
};

// Firestore doc IDs can't contain "/" and shouldn't be empty or absurdly long.
const sanitizeIdPart = (s = "") =>
  String(s).replace(/[/\s]+/g, "-").replace(/[^a-zA-Z0-9._-]/g, "").slice(0, 200) || "unknown";

const buildJobDocId = (source, externalId) =>
  `${sanitizeIdPart(source)}__${sanitizeIdPart(externalId)}`;

const buildJobSourceDocId = (type, key) =>
  `${sanitizeIdPart(type)}__${sanitizeIdPart(key)}`;

module.exports = { hashString, sanitizeIdPart, buildJobDocId, buildJobSourceDocId };
